export const wordpressUrl = process?.env?.['NEXT_PUBLIC_WORDPRESS_URL'];
export const frontendUrl = process?.env?.['NEXT_PUBLIC_SITE_URL'];
export const sitemapPerPage = 50000; // recommended max links per sitemap page by Google
export const cacheControl = 600; // 10 minutes
